import styled from 'styled-components';

import { basicTitleTextStyle, StyledFlex } from '@dreryk/react-components';

export const StyledAdamedExpertAuthenticateOrRedirectButton = styled(StyledFlex)`
   ${basicTitleTextStyle};
   cursor: pointer;
   padding: 8px 16px 7px 16px;
   color: ${(props) => props.theme.white};
   background-color: #144089;
   border-radius: 20px;
   gap: 4px;
   span:nth-of-type(2) {
      margin-top: 1px;
   }
`;
